import {env} from '@/config';
import keycloakAxios from '@/services/axios';
import {EventData} from '@/types/event';
import {Filter} from '@/types/filter';
import {isAllowedTag} from '@/utils';

export const findAllEvents = async (
  page: number,
  filter: Filter = {},
  maxResults?: number,
  company?: string,
  userId?: string,
  tag?: string,
  onDemandEvents?: boolean,
  isPublicCompany?: boolean
) => {
  const {TAG_PAIRS} = env;
  const {startTime, endTime, location, ...restFilter} = filter;
  const max = maxResults || 20;
  const requestBody = {
    ...restFilter,
    company,
    orderBy: {
      field: onDemandEvents ? 'title' : 'start',
      order: 1
    },
    limitValue: max,
    skipValue: max * (page - 1),
    startTime,
    coordinates: location ? location.coordinates : undefined,
    endTime: endTime || (startTime ? '23:00:00' : undefined),
    accessType:
      restFilter.participants && restFilter.participants.length > 0
        ? ['PUBLIC', 'PRIVATE']
        : undefined,
    ageGroups: restFilter.ageGroups?.includes('ALL')
      ? []
      : restFilter.ageGroups,
    tag: isAllowedTag(tag, TAG_PAIRS) ? tag : undefined,
    ignoreRecurring: false,
    userId: userId || undefined,
    noOnDemand: !onDemandEvents ? true : undefined,
    publicCompany: isPublicCompany || undefined
  };

  const endpoint = 'event/' + (onDemandEvents ? 'on-demand' : 'find');

  const response = await keycloakAxios.post(endpoint, requestBody);

  if (response.status >= 300) {
    throw new Error(
      `Error finding all events: Invalid status code: ${response.status}`
    );
  }

  const updatedResponseData = response.data.map((event: EventData) => ({
    ...event,
    price: event.price > 0 ? event.price / 100 : 0
  }));

  return updatedResponseData;
};
